export const conceptmap = {
	REQUEST_CONCEPTMAP:'REQUEST_ALL_CONCEPTMAP',
	RECEIVE_CONCEPTMAP:'RECEIVE_ALL_CONCEPTMAP',
	REQUEST_TOPOLOGY:'REQUEST_TOPOLOGY',
	RECEIVE_TOPOLOGY:'RECEIVE_TOPOLOGY',
}


// WEBPACK FOOTER //
// ./src/constants/widgetConceptmap.constants.js